import type { SVGProps } from "react";

export function AddPlusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19M5 12H19"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MinusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 16 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.700195 0.699219H14.7002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function AddPlusCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12H15M12 9V15M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddPlusCircleFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.92917 4.92927C5.85335 3.98135 6.95656 3.22638 8.1748 2.70815C9.39304 2.18992 10.7021 1.91875 12.0259 1.91036C13.3498 1.90197 14.6621 2.15653 15.8868 2.65928C17.1115 3.16203 18.2242 3.90296 19.1603 4.83909C20.0965 5.77521 20.8374 6.8879 21.3401 8.11261C21.8429 9.33732 22.0975 10.6497 22.0891 11.9735C22.0807 13.2974 21.8095 14.6064 21.2913 15.8246C20.7731 17.0429 20.0181 18.1461 19.0702 19.0703C17.1841 20.8918 14.6581 21.8998 12.0362 21.877C9.41419 21.8542 6.90606 20.8025 5.05198 18.9485C3.1979 17.0944 2.14621 14.5862 2.12342 11.9643C2.10064 9.34231 3.10858 6.81629 4.93017 4.93026L4.92917 4.92927ZM13.0002 9.00027C13.0002 8.73505 12.8948 8.48069 12.7073 8.29316C12.5197 8.10562 12.2654 8.00027 12.0002 8.00027C11.7349 8.00027 11.4806 8.10562 11.2931 8.29316C11.1055 8.48069 11.0002 8.73505 11.0002 9.00027V11.0003H9.00017C8.73495 11.0003 8.4806 11.1056 8.29306 11.2932C8.10552 11.4807 8.00017 11.735 8.00017 12.0003C8.00017 12.2655 8.10552 12.5198 8.29306 12.7074C8.4806 12.8949 8.73495 13.0003 9.00017 13.0003H11.0002V15.0003C11.0002 15.2655 11.1055 15.5198 11.2931 15.7074C11.4806 15.8949 11.7349 16.0003 12.0002 16.0003C12.2654 16.0003 12.5197 15.8949 12.7073 15.7074C12.8948 15.5198 13.0002 15.2655 13.0002 15.0003V13.0003H15.0002C15.2654 13.0003 15.5197 12.8949 15.7073 12.7074C15.8948 12.5198 16.0002 12.2655 16.0002 12.0003C16.0002 11.735 15.8948 11.4807 15.7073 11.2932C15.5197 11.1056 15.2654 11.0003 15.0002 11.0003H13.0002V9.00027Z"
        fill="currentColor"
      />
    </svg>
  );
}
